import { Form, Select } from 'antd';
import { Rule } from 'antd/es/form';
import { ReactComponent as DropdownIcon } from 'assets/icons/simulate-dropdown.svg';
import { OptionEntity } from 'domain/entities/OptionEntity';
import React, { SelectHTMLAttributes } from 'react';
import getMessage from 'utilities/constants/MESSAGE';
import { PLACEHOLDER } from 'utilities/constants/PLACEHOLDER';

export interface SelectProps extends SelectHTMLAttributes<HTMLDivElement> {
    options: OptionEntity[];
    size?: any;
    name?: string;
    disabled?: any;
    required?: boolean;
    requiredMessage?: string;
    callback?: any;
    rules?: Rule[];
    label?: string;
    labelClassName?: string;
    icon?: React.ReactNode;
    onChange?: (value: any) => void;
    placeholder?: string;
}

export const FormSelect = ({
    options,
    rules = [],
    label,
    required,
    requiredMessage,
    labelClassName = '',
    name,
    placeholder = PLACEHOLDER.SELECT,
    icon = <DropdownIcon />,
    size = 'large',
    onChange,
    onSelect,
    ...props
}: SelectProps) => {
    return (
        <>
            <span className={labelClassName}>
                {label}
                {label && required ? <span style={{ color: '#EB5757' }}>*</span> : <></>}
            </span>
            <Form.Item
                required={required}
                className={props.className}
                name={name}
                label={false}
                rules={rules.concat([
                    {
                        required: required ? true : false,
                        message: requiredMessage ?? getMessage('In_Required', label),
                    },
                ])}
            >
                <Select
                    {...props}
                    size={size}
                    className="select-custom "
                    suffixIcon={icon}
                    options={options}
                    placeholder={placeholder}
                    onChange={(value) => {
                        if (onChange) {
                            onChange(value);
                        }
                        props.callback && props.callback(value);
                    }}
                />
            </Form.Item>
        </>
    );
};
